import useHttpHandler from "../../../../hooks/httpHandler";
import { useNavigate, useParams } from "react-router-dom"
import {useState, useEffect} from "react";
import {toast} from "react-toastify";

const useAddVehicleInformation = () => {
    const [vehicleMakesList, setVehicleMakesList] = useState([])
    const routeParams = useParams();
    const {post, get, put} = useHttpHandler()
    const navigate = useNavigate()
    const {vehicleId} = routeParams


    const [loading, setLoading] = useState(false)
    const [vehicleDetails, setVehicleDetails] = useState(null)

    const gotoVehicle = () => {
        navigate('/vehicle')
    }

    const onSubmitAddVehicle=(values, actions)=>{
        post('user/vehicles', values).then((res)=>{

            actions.setSubmitting(false)
            gotoVehicle()
        }).catch(err => {
            actions.setSubmitting(false)
        })
    }

    const onSubmitEditVehicle=(values, actions)=>{
        put('user/vehicles/'+vehicleId, values).then((res)=>{

            actions.setSubmitting(false)
            toast.success('Vehicle details updated')
            gotoVehicle()
        }).catch(err => {
            actions.setSubmitting(false)
        })
    }

    const getVehicleDetailsById = () => {
        setLoading(true)
        get('user/vehicles/'+vehicleId).then((res)=>{
            const data = res.data
            setVehicleDetails(data.vehicle)
            setLoading(false)
        }).catch(err => {
            setLoading(false)
        })
    }
    const getVehicleMakes =  () => {
        setLoading(true)
        get('user/vehicles/makes').then((res)=>{
            const data = res.data
            let makeList = []
            res.data.vehicle_makes.map((item,index)=>{
                let newItem = {
                    label: item.name,
                    value: item.name
                }
                makeList.push(newItem)
            })
            setVehicleMakesList(makeList)
            setLoading(false)
        }).catch(err => {
            setLoading(false)
        })
    }
    useEffect(()=>{
        if(vehicleId && !vehicleDetails) {
            getVehicleDetailsById()
        }
        if(vehicleMakesList?.length >= 0) {
            getVehicleMakes()
        }
    },[])
    return{
        onSubmitAddVehicle,
        loading,
        getVehicleDetailsById,
        vehicleDetails,
        onSubmitEditVehicle,
        vehicleMakesList

    }
}

export default useAddVehicleInformation